import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { useTranslation } from "react-i18next";

interface NextGenerationEUProps {
  itemsColor?: "light" | "dark";
}

const NextGenerationEU: React.FC<NextGenerationEUProps> = ({ itemsColor = "light" }) => {
  const { t } = useTranslation("global");

  return (
    <div className={`m-next-generation-eu`}>
      <div className={"next-generation-eu__group"}>
        <p className={`next-generation-eu__text next-generation-eu__text--${itemsColor}`}>
          {t("Financiado por la Unión Europea ")}
        </p>
        <p className={`next-generation-eu__text next-generation-eu__text--guion`}>-</p>
        <p className={`next-generation-eu__text next-generation-eu__text--${itemsColor}`}>{t("Next Generation EU")}</p>
      </div>
      <div className={`next-generation-eu__deals next-generation-eu__deals--${itemsColor}`}>
        <div className="image-wrapper">
          <StaticImage src={"plan-recuperacion.png"} alt={t("Sello plan de recuperación")} width={200} />
        </div>
        <div className="image-wrapper">
          <StaticImage src={"europa.png"} alt={t("Sello Financiado por la Unión Europea")} width={200} />
        </div>
      </div>
    </div>
  );
};

export default NextGenerationEU;
